// 日付文字列(YYYY-MM-DD)の日が月末を超えていたら月末日に丸める
export const clampDate = (val) => {
    if (!val) return val;
    const [y, m, d] = val.split('-').map(Number);
    if (!y || !m || !d) return val;
    const lastDay = new Date(y, m, 0).getDate();
    if (d > lastDay) {
        return `${y}-${String(m).padStart(2, '0')}-${String(lastDay).padStart(2, '0')}`;
    }
    return val;
};

export const formatDate = (dateStr) => {
    if (!dateStr) return '';
    const date = new Date(dateStr);
    return `${date.getFullYear()}/${String(date.getMonth() + 1).padStart(2, '0')}/${String(date.getDate()).padStart(2, '0')}`;
};

export const getCurrentFiscalYear = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = now.getMonth() + 1;
    // 決算期が3月なので、4月以降はその年度、1-3月は前年度
    // 例: 2025年4月〜2026年3月 = 2025年度
    return month >= 4 ? year : year - 1;
};

export const getFiscalYearRange = (fiscalYear) => {
    // 例: 2025年度 = 2025/4/1〜2026/3/31
    return {
        start: `${fiscalYear}-04-01`,
        end: `${fiscalYear + 1}-03-31`
    };
};

// 個人事業主用の年度範囲（1月〜12月）
export const getIndividualFiscalYearRange = (fiscalYear) => {
    return {
        start: `${fiscalYear}-01-01`,
        end: `${fiscalYear}-12-31`
    };
};
